import React from 'react';
import FileView from '../components/Views/FileView';
import MeetView from '../components/MeetView/MeetView';
import HomeView from '../components/Home/HomeView';
import { classicHomeAsyncPropExtender } from './classicHomeAsyncProps';

export default function install(config) {
  config.views.contentTypesViews.File = FileView;
  // The site root: the redesigned home page, or the classic one.
  // In Volto, layoutViews.document_view takes precedence over contentTypesViews,
  // so intercept document_view for the Plone Site root.
  const DefaultDocumentView = config.views.layoutViews.document_view;
  config.views.layoutViews.document_view = (props) => {
    if (props.content?.['@type'] === 'Plone Site') {
      return React.createElement(HomeView, props);
    }
    return React.createElement(DefaultDocumentView, props);
  };
  config.views.contentTypesViews['Plone Site'] = HomeView;
  // Every meet, past and future; data from the meet-documents expander
  config.views.contentTypesViews.Event = MeetView;
  config.settings.apiExpanders = [
    ...config.settings.apiExpanders,
    { match: '', GET_CONTENT: ['meet-documents'] },
  ];
  config.settings.asyncPropsExtenders = [
    ...config.settings.asyncPropsExtenders,
    classicHomeAsyncPropExtender,
  ];

  if (__SERVER__) {
    const displayPdfMiddleware =
      require('../express-middleware/displayPdf').default;
    const staleAuthCookieMiddleware =
      require('../express-middleware/staleAuthCookie').default;
    const lookSwitchMiddleware =
      require('../express-middleware/lookSwitch').default;
    config.settings.expressMiddleware = [
      ...config.settings.expressMiddleware,
      lookSwitchMiddleware(),
      staleAuthCookieMiddleware(),
      displayPdfMiddleware(),
    ];
  }

  return config;
}
